export interface OrbitalElementsOut {
  a_au: number | null;
  e: number | null;
  i_deg: number | null;
  Omega_deg: number | null;
  omega_deg: number | null;
  M_deg: number | null;
  q_au: number | null;
  Q_au: number | null;
}

export interface SmallBody {
  key: string;
  designation: string | null;
  name: string;
  object_class: string;
  elements: OrbitalElementsOut;
  horizons_command: string | null;
  position_helio_au: [number, number, number] | null;
  position_uncertain: boolean;
  source: string;
}

export interface ObjectsSearchResponse {
  count: number;
  items: SmallBody[];
  source: string;
  cached: boolean;
}

export async function fetchSmallBodies(params: Record<string, string | number> = {}): Promise<ObjectsSearchResponse> {
  const url = new URL('/api/objects/search', window.location.origin);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, String(v));
  });
  const r = await fetch(url.toString());
  if (!r.ok) {
    if (r.status === 404) return { count: 0, items: [], source: 'empty', cached: false };
    throw new Error(`/api/objects/search HTTP ${r.status}`);
  }
  return r.json();
}
